// extracted by mini-css-extract-plugin
export default {"root":"EmailOnly_root__3eudv","form":"EmailOnly_form__1qrM7","links":"EmailOnly_links__19-hw","link":"EmailOnly_link__3goho"};